import { defineAction } from '~/prix'
import { z } from 'zod'
import llmTemplateSearchAction from './llmTemplateSearch.action.json' with { type: 'json' }

const llmTemplateSearchDefinition = defineAction({
  ...llmTemplateSearchAction,

  input: z.object({
    search: z.string().describe('Termo de busca para encontrar templates relevantes'),
    mode: z.enum(['chat', 'report']).describe('Modo de template'),
  }),

  output: z.object({
    results: z.array(
      z.object({
        id: z.number(),
        type: z.string(),
        name: z.string(),
        content: z.string(),
        sqlQueries: z.array(z.string()),
        tables: z.array(z.string()),
        pythonCodes: z.array(z.string()),
        necessaryTools: z.array(z.string()),
        score: z.number(),
        origin: z.enum(['vector', 'trgm', 'both']),
      }),
    ),
  }),
})

export default llmTemplateSearchDefinition
